module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_t-monet_m.9809b04b48b048d60041f51f2c2bee12.png";